import * as React from 'react';
export const PWSvg = React.forwardRef(function PWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#45B2E8',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 6,
        cy: 6,
        r: 3,
        fill: '#FCD669',
      }),
    ),
  );
});
PWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PW = {
  category: 'flag',
  colorable: false,
  name: 'PW',
  svg: PWSvg,
};
